import { FC } from 'react';
import { Button, Box, styled } from '@mui/material';
import PhoneIcon from '@mui/icons-material/Phone';

const CallButtonComponent = styled(Button)(({ theme }) => ({
	'&.MuiButtonBase-root:hover': {
		backgroundColor: 'transparent',
	},
	marginTop: '12px',
	fontWeight: 'bold',
	textTransform: 'capitalize',
	display: 'flex',
	justifyContent: 'flex-start',
	alignItems: 'center',
	borderColor: theme.palette.primary.main,
	fontSize: '1.08rem',
	color: theme.palette.primary.main,
}));

const callButtonLabelStyle = {
	display: 'flex',
	justifyContent: 'center',
	alignItems: 'center',
	width: '100%',
};

interface ICallButtonProps {
	buttonLabel: string;
	phoneNumber: string;
}

const CallButton: FC<ICallButtonProps> = ({ buttonLabel, phoneNumber }) => {
	return (
		<CallButtonComponent
			href={`tel:${phoneNumber}`}
			variant='outlined'
			startIcon={<PhoneIcon style={{ fontSize: '2rem' }} />}
		>
			<Box sx={callButtonLabelStyle}>{buttonLabel}</Box>
		</CallButtonComponent>
	);
};

export default CallButton;
